import { type MantineTheme } from '@mantine/core'

const cssVariablesResolver = (theme: MantineTheme) => {
  const colorLayers = {
    dark: {
      'layer-0': theme.colors.zinc[10],
      'layer-1': theme.colors.zinc[9],
      'layer-2': theme.colors.zinc[8],
    },
    light: {
      'layer-0': theme.colors.zinc[1],
      'layer-1': theme.white,
      'layer-2': theme.white,
    },
  }
  return {
    variables: {},
    light: {
      // Layer colors
      '--mantine-color-layer-0': colorLayers.light['layer-0'],
      '--mantine-color-layer-1': colorLayers.light['layer-1'],
      '--mantine-color-layer-2': colorLayers.light['layer-2'],

      // Layout colors
      '--mantine-color-body': colorLayers.light['layer-0'],
      '--mantine-color-background': colorLayers.light['layer-1'],
      '--mantine-color-border': theme.colors.zinc[2],

      // Text colors
      '--mantine-color-text': theme.colors.zinc[8],
      '--mantine-color-text-secondary': theme.colors.zinc[5],
      '--mantine-color-text-disabled': theme.colors.zinc[3],
    },
    dark: {
      // Layer colors
      '--mantine-color-layer-0': colorLayers.dark['layer-0'],
      '--mantine-color-layer-1': colorLayers.dark['layer-1'],
      '--mantine-color-layer-2': colorLayers.dark['layer-2'],

      // Layout colors
      '--mantine-color-body': colorLayers.dark['layer-0'],
      '--mantine-color-background': colorLayers.dark['layer-1'],
      '--mantine-color-border': theme.colors.zinc[8],

      // Text colors
      '--mantine-color-text': theme.colors.zinc[2],
      '--mantine-color-text-secondary': theme.colors.zinc[4],
      '--mantine-color-text-disabled': theme.colors.zinc[7],
    },
  }
}

export default cssVariablesResolver
